import React from 'react';
import { AwardIcon, CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, included, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-slate-950 py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-164" data-mp="1j9gzgtubtlbh">
      <div className="mx-auto max-w-3xl px-4" data-id="element-165" data-mp="1nbbzlv0itsno">
        <h2 id="pricing-title" className="text-center text-3xl font-extrabold text-white sm:text-4xl" data-id="element-166" data-mp="1ncn3dutyv0es">
          Choose your option
        </h2>

        <article className="mt-10 overflow-hidden rounded-2xl border-2 border-slate-300 bg-slate-800 shadow-2xl shadow-black/40" data-id="element-167" data-mp="1x8gmxy63ru62">
          <div className="flex items-center justify-between gap-4 border-b border-slate-400/20 bg-slate-700 px-6 py-4 sm:px-10" data-id="element-168" data-mp="227b46vof9ao2">
            <span className="inline-flex items-center gap-2 rounded-full metal px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.14em] text-slate-950" data-id="element-169" data-mp="2x1rr1ubp2ix">
              <AwardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-170" data-mp="1mi99x2rwowj9" /> Main offer
            </span>
            <span className="text-xs font-bold uppercase tracking-[.14em] text-slate-200" data-id="element-171" data-mp="1hodfgaauprsu">Launch price today</span>
          </div>
          <div className="p-6 sm:p-10" data-id="element-172" data-mp="1coine3fcaw67">
            <div className="flex flex-col gap-6 border-b border-slate-400/15 pb-7 sm:flex-row sm:items-end sm:justify-between" data-id="element-173" data-mp="17sjuc2j2gpzg">
              <div data-id="element-174" data-mp="25f0pp288otik">
                <h3 className="text-2xl font-extrabold leading-tight text-white" data-id="element-175" data-mp="25dg3bzw2wgvs">{productShortName}</h3>
                <p className="mt-2 text-sm text-slate-300" data-id="element-176" data-mp="20emrsd0cqzy9">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses ready to use in your classroom.
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-177" data-mp="k27qb2qxzde5">
                <span className="text-sm text-slate-300" data-id="element-178" data-mp="k3r5eq0v3iec">
                  Regular price <span className="line-through" data-id="element-179" data-mp="g0cn1spgapxq">{priceBefore}</span>
                </span>
                <p className="metal-text mt-1 whitespace-nowrap text-5xl font-extrabold" data-id="element-180" data-mp="hh8dnojt6nct">{price}</p>
                <p className="text-xs font-bold uppercase tracking-[.14em] text-slate-400" data-id="element-181" data-mp="mhe451ece3tb">Today</p>
              </div>
            </div>

            <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-182" data-mp="7j27uvuvsx2o">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-slate-100" data-id="element-183" data-mp="cgu0xt79ip8g">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-slate-300" aria-hidden="true" data-id="element-184" data-mp="3uvd228kvjz9g" />
                  {item}
                </li>)}
            </ul>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-185" data-mp="3kzt4ziukquj4">
              Get my teacher ready now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-slate-300" data-id="element-186" data-mp="3bxjxl1ulrh9y">
              <span className="inline-flex items-center gap-1.5" data-id="element-187" data-mp="3fy3uq5f6ekw3">
                <LockIcon className="h-4 w-4 text-slate-200" aria-hidden="true" data-id="element-188" data-mp="2xatq1iqacsfx" /> Secure payment
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-189" data-mp="2scs66vl1cp3e">
                <ZapIcon className="h-4 w-4 text-slate-200" aria-hidden="true" data-id="element-190" data-mp="36bru210q4zyi" /> Instant access
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-191" data-mp="31c6ubodqcnkq">
                <ShieldCheckIcon className="h-4 w-4 text-slate-200" aria-hidden="true" data-id="element-192" data-mp="31f1dzdox64d3" /> 7-day guarantee
              </span>
            </div>
            <p className="mt-4 text-center text-xs text-slate-400" data-id="element-193" data-mp="3bbny209f8re2">
              You pay in USD. Your payment platform automatically shows the conversion to your local currency.
            </p>
          </div>
        </article>
      </div>
    </section>;
}